import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getLocalized, getURLParam, mapStateToProps, setTableParams } from "../../core/utils";
import { createSuperadminSidebar } from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import {
	deleteSpecificationGroups,
	listSpecificationGroups,
	readSpecificationGroup
} from "../../redux/actions/table/superadmin/specification_groups";
import SpecificationGroupsFlyout from "../../flyouts/superadmin/specification_groups/SpecificationGroupsFlyout";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_specification_groups"],
	application_language_id: state.auth.language_id,
}))
class SpecificationGroups extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_specification_group && setPlusActions([{
			title: "Add specification group",
			onClick: () => setTableParams('superadmin_specification_groups', {
				add_specification_group_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readSpecificationGroup(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, application_language_id } = this.props;

		const columns = [
			{
				key: "id",
				name: "ID",
				width: 60,
				sortable: false
			},
			{
				key: "name",
				name: "Name",
				value: name => getLocalized(name, application_language_id)
			},
			{
				key: "code",
				name: "Code",
				width: 60,
				value: code => getLocalized(code, application_language_id)
			},
		];

		const singleActions = (specification_group_id) => {
			return [
				<Tooltip text="Delete selected specification group" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected specification group?\n\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteSpecificationGroups([specification_group_id]).then(() => {
												hideAlertbox();

												setNotification("The selected specification group has been deleted.");
												listSpecificationGroups();

												setTableParams('superadmin_specification_groups', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (specification_groups_ids) => [
			<Tooltip text="Delete selected specification groups" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these specification groups?\n\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteSpecificationGroups(specification_groups_ids).then(() => {
											hideAlertbox();

											setNotification("The selected specification groups have been deleted.");
											listSpecificationGroups();

											setTableParams('superadmin_specification_groups', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<SpecificationGroupsFlyout
				data={this.state.preview}
				readAction={specification_group_id => {
					return new Promise(resolve => {
						readSpecificationGroup(getURLParam('id') || specification_group_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listSpecificationGroups}
				name="superadmin_specification_groups"
				groupActions={superadmin.delete_specification_group && groupActions}
				singleActions={superadmin.delete_specification_group && singleActions}
				title={__("modules.submodules.title.specification-groups")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default SpecificationGroups;
